/**
 * Reads the `preview` and `project` query params from the current URL.
 *
 * CMS client query and fetch functions use these to thread preview state and
 * the Comments `project` context (which routes reads through the comment API)
 * into their requests. Centralized here so the parsing lives in one place
 * rather than being re-implemented in every fetcher.
 */
export const getCmsPreviewProjectParams = (): {
  previewId: string | null;
  projectId: string | null;
} => {
  const urlParams = new URLSearchParams(window?.location?.search || {});

  return {
    previewId: urlParams.get('preview'),
    projectId: urlParams.get('project'),
  };
};
